import classNames from 'classnames'
import { WorkWithParsedSrts } from '../pages/api/work/[id]'
import { useEngine, useWebAudio } from '../lib/playerHooks'
import { AudioController } from './AudioController'
import { ProgressBar } from './ProgressBar'
import { TimeRemaining } from './TimeRemaining'

type PlayerProps = {
  work: WorkWithParsedSrts;
}

export const Player: React.FC<PlayerProps> = ({ work }: PlayerProps) => {
  useEngine(work)
  const webAudioIsPlaying = useWebAudio()
  const showAudioController = work.tracks?.length || work.audioUrl || webAudioIsPlaying
  const playerClasses = classNames({
    'player-container': true,
    'player-container__with-audio': showAudioController,
  })
  return (
    <div className={playerClasses}>
      <ProgressBar updateInterval={1} />
      <div className="controls">
        <span
          className="work-title text__active quill-content-inline"
          dangerouslySetInnerHTML={{ __html: work.title }}
        />
        <div className="buttons">
          {showAudioController && <AudioController work={work} />}
          <TimeRemaining updateInterval={250} />
        </div>
      </div>
    </div>
  )
}
